import { render, staticRenderFns } from "./MediaData.vue?vue&type=template&id=1f565436&scoped=true&"
import script from "./MediaData.vue?vue&type=script&lang=ts&"
export * from "./MediaData.vue?vue&type=script&lang=ts&"
import style0 from "./MediaData.vue?vue&type=style&index=0&id=1f565436&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f565436",
  null
  
)

export default component.exports